import "./ServiceAreas.module.css";
import Navbar from "@/reusable_sections/Header";
import Coverage from "./sections/Coverage";
import Locations from "./sections/Locations";
import Process from "./sections/Process";
import Action from "./sections/Action";
import Footer from "@/reusable_sections/Footer";
export default function ServiceAreasPage() {
  return <div>
      <Navbar />
      <Coverage />
      <Locations />
      <Process />
      <Action />
      <Footer />
    </div>;
}